export enum HrVenturePerformanceModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
